import { render, staticRenderFns } from "./mother.vue?vue&type=template&id=06223b56&scoped=true&"
import script from "./mother.vue?vue&type=script&lang=js&"
export * from "./mother.vue?vue&type=script&lang=js&"
import style0 from "./mother.vue?vue&type=style&index=0&id=06223b56&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06223b56",
  null
  
)

export default component.exports